import React, { useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import ListTable from "./components/ListTable";
import { AppDispatch } from "../../../store/app";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import InternalRoutingForm from "./components/InternalRoutingForm";
import ProviderCodeForm from "./components/ProviderCodeForm";
import { Button, Tabs } from "antd";
import { getInternalCodeList } from "../../../store/NumberManagementSlice";
import CheckForm from "./components/CheckForm";
import { checkPrivileges } from "../../../config/Global";
import { CONSTANT } from "../../../config/Constant";
import BulkAddInternalRoutingNumber from "./components/BulkAddInteralRoutingNumber";

const InternalNumberRouting: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState<string>("1");
  const [listData, setListData] = useState<any[]>([]);
  const [openCsvModal, setOpenCsvModal] = useState(false);
  const [totalData, setTotalData] = useState<any>(0);
  const [tableloading, setTableLoading] = useState<boolean>(false);
  const [paginationData, setPaginationData] = useState<any>({
    current: 1,
    page_size: 10,
  });

  const userDetails = localStorage.getItem("userDetails");
  const userRoles = userDetails && JSON.parse(userDetails)?.roles;

  const getList = (data?: any) => {
    if (activeTab === "4") {
      setTableLoading(true);
      const payload = {
        ...data,
        current: data?.current ?? paginationData?.current ?? 1,
        page_size: data?.page_size ?? paginationData?.page_size ?? 10,
        // user_id: '661e722d74bca72daa7d1a3b',
      };
      dispatch(getInternalCodeList(payload))
        .then((res: any) => {
          setListData(res?.data);
          setTotalData(res?.total_data);
          setTableLoading(false);
        })
        .catch(() => {
          setListData([]);
          setTotalData(0);
          setTableLoading(false);
        });
    }
  };

  const handleCsvModal = () => {
    setOpenCsvModal(true);
  };

  const closeCsvModal = () => {
    setOpenCsvModal(false);
  };

  const token = localStorage.getItem("token");
  useEffect(() => {
    if (token && token !== "undefined") {
      getList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const runWebSocket = (ws: any) => {
    ws.onopen = function () {
      //console.log('WebSocket connection established');
    };

    ws.onclose = function () {
      //console.log('WebSocket connection closed');
    };

    ws.onmessage = function (event) {
      const eventData = JSON.parse(event.data);
      // const eventData = event.data;
      // //console.log('eventData', eventData);
      // //console.log('eventData', eventData);
      const token = localStorage.getItem("token");
      if (token === null) {
        navigate("/login");
      }

      const getNumber = eventData?.user_id;
      // setDataViewDrawer({ number: getNumber });

      if (getNumber) {
        // setApiResponse(getNumber);
        getList();
      } else {
        ws.close();
      }
    };
  };
  useEffect(() => {
    const ws = new WebSocket(CONSTANT.WS_URL);
    runWebSocket(ws);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ToolBar
        title={"Internal Number Routing"}
        children={
          (activeTab === "1" || activeTab === "2") && (
            <>
              <Button type="default" onClick={handleCsvModal}>
                Bulk Add
              </Button>
            </>
          )
        }
      />
      <Tabs
        defaultActiveKey="1"
        type="card"
        size="large"
        // onTabClick={
        //   () => getList()
        //   // (key === '4' ? getList() : null)
        // }
        onChange={(key: string) => setActiveTab(key)}
        destroyInactiveTabPane={true}
        items={[
          {
            key: "1",
            label: "Add Routing Number",
            children: <InternalRoutingForm mode="add" />,
          },
          {
            key: "2",
            label: "Update Routing Number",
            children: <InternalRoutingForm mode="update" />,
          },
          {
            key: "3",
            label: "Check Routing Number",
            children: <CheckForm />,
          },
          {
            key: checkPrivileges(userRoles, "admin") ? "4" : "",
            label: checkPrivileges(userRoles, "admin")
              ? "Internal Provider Code"
              : "",
            children: checkPrivileges(userRoles, "admin") ? (
              <ProviderCodeForm getList={getList} />
            ) : null,
            disabled: checkPrivileges(userRoles, "admin") ? false : true,
          },
        ]}
      />
      <BulkAddInternalRoutingNumber
        close={closeCsvModal}
        visible={openCsvModal}
      />
      {activeTab === "4" && (
        <ListTable
          listData={listData}
          setListData={setListData}
          tableloading={tableloading}
          getList={getList}
          totalData={totalData}
          paginationData={paginationData}
          setPaginationData={setPaginationData}
          setTableLoading={setTableLoading}
        />
      )}
    </>
  );
};

export default InternalNumberRouting;
